import React from "react";
import { render } from "react-dom";
import { createInertiaApp } from "@inertiajs/inertia-react";
import { InertiaProgress } from "@inertiajs/progress";

import "swiper/css";
import "swiper/css/navigation";

createInertiaApp({
    // title: (title) => `${title} - WE ARE: PERSONAL TRAINING UDEN EN SCHIJNDEL`,
    title: (title) => "WE ARE: PERSONAL TRAINING UDEN EN SCHIJNDEL",
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, App, props }) {
        return render(<App {...props} />, el);
    },
});

InertiaProgress.init({ color: "#4B5563" });
